import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { ReferralInvite } from "@/components/ReferralInvite";
import { UserPlus } from "lucide-react";

export function InviteButton({ variant = "header" }) {
  const [open, setOpen] = useState(false);
  const trigger = variant === "cta" ? (
    <button data-testid="invite-btn-cta"
      className="inline-flex items-center gap-2 px-4 py-2 bg-[hsl(var(--pitch-green))] text-black font-bold uppercase text-xs tracking-wider hover:brightness-110 transition-all">
      <UserPlus size={15} /> Invite a mate
    </button>
  ) : (
    <button data-testid="invite-btn"
      title="Invite a mate — bring the banter"
      className="hidden md:inline-flex items-center gap-1.5 px-2 py-1 border border-[hsl(var(--pitch-green))]/60 text-[hsl(var(--pitch-green))] text-[10px] uppercase tracking-wider hover:bg-[hsl(var(--pitch-green))]/10 transition-colors">
      <UserPlus size={12} /> Invite
    </button>
  );
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="bg-card border-2 border-[hsl(var(--pitch-green))] rounded-none max-w-md" data-testid="invite-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl uppercase flex items-center gap-2">
            <UserPlus className="text-[hsl(var(--pitch-green))]" size={24} /> Bring your mates
          </DialogTitle>
          <DialogDescription className="font-data text-xs">
            The more gaffers, the better the banter. Share your link:
          </DialogDescription>
        </DialogHeader>
        <ReferralInvite />
      </DialogContent>
    </Dialog>
  );
}
